import { emission_certificate_document_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateEmissionCertificateDocumentTypeEnum = (enumValue: emission_certificate_document_type_enum) => {
  switch (enumValue) {
    case emission_certificate_document_type_enum.CERTIFICATE_OF_ORIGIN:
      return <Trans i18nKey="Enum_EmissionCertificateDocumentTypeEnum-CERTIFICATE_OF_ORIGIN" />;
    case emission_certificate_document_type_enum.EMISSION_CERTIFICATE:
      return <Trans i18nKey="Enum_EmissionCertificateDocumentTypeEnum-EMISSION_CERTIFICATE" />;
    case emission_certificate_document_type_enum.OTHER:
      return <Trans i18nKey="Enum_EmissionCertificateDocumentTypeEnum-OTHER" />;
  }
};

export const translateEmissionCertificateDocumentTypeEnum_dynamic = (
  enumValue: emission_certificate_document_type_enum,
) => {
  const t = getI18n().t;
  switch (enumValue) {
    case emission_certificate_document_type_enum.CERTIFICATE_OF_ORIGIN:
      return t('Enum_EmissionCertificateDocumentTypeEnum-CERTIFICATE_OF_ORIGIN');
    case emission_certificate_document_type_enum.EMISSION_CERTIFICATE:
      return t('Enum_EmissionCertificateDocumentTypeEnum-EMISSION_CERTIFICATE');
    case emission_certificate_document_type_enum.OTHER:
      return t('Enum_EmissionCertificateDocumentTypeEnum-OTHER');
  }
};
